module.exports = __webpack_public_path__ + "img/rightthigh-ecto-mesomorph-female.8d8d7491.svg";